<template>
    <div class="cumulative-card-wrapper">
        <div class="tit">{{ data.title }}</div>
        <div :class="{ cent: true, 's-cent': data.partial.length == 0 }">
            <div v-for="(item, index) in data.overall" :key="index">
                <div class="num">{{ item.value }}</div>
                <div>{{ item.name }}</div>
            </div>
        </div>
        <div class="cent-bot" v-if="data.partial.length > 0">
            <div class="item" v-for="(item, index) in data.partial" :key="index">
                <p>{{ item.value }}</p>
                <p class="txt">{{ item.name }}</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CumulativeCard",
    props: ["data"]
};
</script>

<style lang="scss" scoped>
.cumulative-card-wrapper {
    padding: 12px 16px;
    height: 200px;
    flex: 1;
    border: 1px solid #d9e4ef;
    background: #fff;
    border-radius: 4px;
    margin-right: 16px;
    box-sizing: border-box;

    .tit {
        margin: 0 0 -8px;
        font-weight: bold;
        font-size: 14px;
        display: flex;
        padding: 0 0 8px;
    }

    .cent {
        color: #9b9ba3;
        font-size: 12px;
        display: flex;
        margin-top: 24px;
        justify-content: space-around;

        .num {
            color: #41475e;
            font-size: 34px;
            line-height: 1.3;
        }
    }

    .s-cent {
        margin-top: 45px;
    }

    .cent-bot {
        padding-top: 8px;
        border-top: 1px solid #d9e4ef;
        margin-top: 28px;
        display: flex;
        justify-content: space-around;

        .item {
            font-size: 17px;
            text-align: center;
            color: #41475e;
            line-height: 1.3;

            .txt {
                color: #9b9ba3;
                font-size: 12px;
            }
        }
    }
}
</style>
